import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button, Row, Col } from "react-bootstrap";
import { useStateContext } from "../contexts/ContextProvider";
import { toast, ToastContainer } from "react-toastify";

const RoleManagementForm = ({
  roles,
  handleAddRole,
  handleUpdateRole,
  closeModal,
}) => {
  const { currentColor, currentMode } = useStateContext();

  const [updateRoleInitialValues, setUpdateRoleInitialValues] = useState({
    selectedRole: "",
    updatedRoleName: "",
  });

  const handleAddButtonClick = async (values, { setSubmitting }) => {
    values.name = values.role;
    console.log(values, "*******************");
    try {
      const role_create = await handleAddRole(values, {
        setSubmitting,
        resetForm: () => resetFormValues(),
      });

      closeModal(); // Close modal after successful addition
    } catch (error) {
      console.error("Error adding role:", error);
    }
  };

  const handleUpdateButtonClick = async (values, { setSubmitting }) => {
    try {
      await handleUpdateRole(values, {
        setSubmitting,
        resetForm: () => resetFormValues(),
      });
      closeModal(); // Close modal after successful update
    } catch (error) {
      console.error("Error updating role:", error);
    }
  };

  const resetFormValues = () => {
    // Reset form values after submission
    setUpdateRoleInitialValues({
      selectedRole: "",
      updatedRoleName: "",
    });
  };

  // Validation schema for add role form
  const roleValidationSchema = Yup.object({
    role: Yup.string()
      .required("Role  is required")
      .min(3, "Too Short!")
      .max(30, "Too Long!"),
  });

  // Validation schema for update role form
  const updateRoleValidationSchema = Yup.object({
    selectedRole: Yup.string().required("Select a role"),
    updatedRoleName: Yup.string()
      .required("Role Name is required")
      .min(3, "Too Short!")
      .max(50, "Too Long!"),
  });

  return (
    <Row className="mt-4 flex justify-center">
      {/* Add Role Form */}
      <Col md={5}>
        <React.Fragment className={"p-2"}>
          <h6
            style={{
              paddingBottom: "4px",
              fontFamily: "Poppins",
            }}
          >
            Create new role
          </h6>
          <Formik
            initialValues={{ role: "" }}
            validationSchema={roleValidationSchema}
            onSubmit={handleAddButtonClick}
          >
            {({ isSubmitting }) => (
              <Form
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  maxWidth: "400px",
                }}
              >
                <div className="form-group mb-4">
                  <label
                    htmlFor="role"
                    className=" mb-2 text-sm  custom-form-label" 
                  >
                    Role Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <Field
                    name="role"
                    type="text"
                    className="border text-sm    w-full  custom-form-control" 
                      
                  />
                  <ErrorMessage
                    name="role"
                    component="div"
                    className="text-red-500 mt-1 text-sm"
                  />
                </div>
                <div className="flex justify-start">
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    style={{ backgroundColor: currentColor, color: "white" }}
                    className="btn btn-primary  custom-form-label "
                  >
                    Add
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </React.Fragment>
      </Col>
      {/* Vertical Divider */}
      <Col md={1} className="d-flex align-items-center justify-content-center">
        <div style={{ borderLeft: "1px solid #ccc", height: "100%" }}></div>
      </Col>
      {/* Update Role Form */}
      <Col md={5}>
        <h6
          style={{
            // borderBottom: `1px solid ${currentColor}`,
            paddingBottom: "4px",
            fontFamily: "Poppins",
          }}
        >
          Update role
        </h6>
        <Formik
          initialValues={updateRoleInitialValues}
          validationSchema={updateRoleValidationSchema}
          onSubmit={handleUpdateButtonClick}
        >
          {({ isSubmitting }) => (
            <Form style={{ width: "90%" }}>
              <div className="form-group mb-4">
                <label
                  htmlFor="selectedRole"
                  className="custom-form-label "
                >
                  Select Role <span style={{ color: "red" }}>*</span>
                </label>
                <Field
                  as="select"
                  name="selectedRole"
                  className=" form-control border text-sm   w-full   custom-form-control "
                    
                >
                  <option value="">Select a role</option>
                  {roles.map((role) => (
                    <option key={role._id} value={role._id}>
                      {role.name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="selectedRole"
                  component="div"
                  className="text-red-500 mt-1 text-sm"
                />
              </div>
              <div className="form-group mb-4">
                <label
                  htmlFor="updatedRoleName"
                  className=" mb-2 text-sm   custom-form-label" 
                >
                  Role Name <span style={{ color: "red" }}>*</span>
                </label>
                <Field
                  name="updatedRoleName"
                  type="text"
                  className="border text-smm  w-full   custom-form-control" 
                />
                <ErrorMessage
                  name="updatedRoleName"
                  component="div"
                  className="text-red-500 mt-1 text-sm"
                />
              </div>
              <div className="flex justify-start">
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  style={{ backgroundColor: currentColor, color: "white" }}
                  className=".custom-form-button "
                >
                  Update
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Col>
      <ToastContainer />
    </Row>
  );
};

export default RoleManagementForm;
